/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ViolationsResponse = zod
	.array(
		zod
			.object({
				case_id: zod.uuid().describe('Associated case ID'),
				case_item_id: zod.uuid().describe('Associated case item ID'),
				confidence: zod.number().nullable().describe('Per-violation confidence score'),
				id: zod.uuid().describe('Violation ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				organization_id: zod.uuid().describe('Organization ID'),
				praetor_id: zod.uuid().describe('Praetor ID'),
				reasoning: zod.string().describe('Detailed reasoning for this specific violation'),
				severity: zod.number().nullable().describe('SEV0..SEV5 severity bucket'),
				trial_id: zod.uuid().describe('Associated trial ID'),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp'),
				violated_policy_plan_id: zod.uuid().describe('ID of the policy plan that was violated'),
				violated_policy_plan_version_id: zod
					.uuid()
					.nullable()
					.describe('ID of the policy plan version that was violated')
			})
			.describe('A specific policy violation within a trial')
	)
	.describe('List of violations');

export type ViolationsResponse = zod.input<typeof ViolationsResponse>;
export type ViolationsResponseOutput = zod.output<typeof ViolationsResponse>;
